import type { ChangeEvent, MouseEvent } from 'react'

export const stopPropagation = (
  event: MouseEvent<HTMLInputElement | HTMLButtonElement | HTMLDivElement> | ChangeEvent<HTMLInputElement>
): void => event.stopPropagation()
